<template>
    <g class="y-axis label" :transform="`translate(${boundary.minX}, 0)`">
        <g v-for="(point, index) in points" :key="index"
            class="y-axis--tick"
            :transform="`translate(${boundary.marginLeft + tickPadding}, ${point.y + boundary.padding})`"
        >
            <text
                class="y-axis--label-text"
                :style="labelStyle"
                :font-size="`${tickSize}rem`"
                :title="point.label"
            >
                <slot name="y-axis" :item="{ ...point, index }"></slot>
            </text>
        </g>
    </g>
</template>

<script>
export default {
    props: [
        'boundary',
        'tickSize',
        'tickPadding',
        'labelColor',
        'points'
    ],
    computed: {
        labelStyle () {
            return {
                'text-anchor': 'end',
                fill: this.labelColor
            }
        }
    }
}
</script>

<style lang="scss" scoped>
text {
    user-select: none;
}
</style>
